<template>
    <div>
        <div class="d-flex justify-content-center" v-if="loading">
            <b-spinner variant="secondary" type="grow"/>
        </div>
        <multi-me-exercise-container
            v-else-if="exerciseData"
            :exercise="exerciseData.exercise"
            :is-admin="exerciseData.clear"
            :traits="exerciseData.traits"
            :page-id="this.unitType === 'page' ? $route.params.id : null" 
        />
    </div>
</template>

<script>
import MultiMeExerciseContainer from "../../../templates/MultiMeExerciseContainer";

export default {
    name: "MultiMeBlock",
    components: {MultiMeExerciseContainer},
    props:{
        unitType: String,
        unitId: String | Number
    },
    data(){
        return{
            loading: true,
            exerciseData: null
        }
    },
    mounted(){
        this.$axios.get(`/api/rest/multime/init/${this.unitType}/${this.unitId}`)
            .then(res => {
                this.loading = false;
                this.exerciseData = res.data;
            })
            .catch(err => {
                this.loading = false;
                console.log(err);
            })
    }
}
</script>